import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { checkoutReviewAndSubmitPaymentDetailsStyles as styles } from "@waytek/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { colorStrings, fontFamily } from "@waytek/Utilities/variables";
import { checkoutInputSelectorStyling } from "@waytek/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { css } from "styled-components";

styles.paymentDetailsHeading = {
    ...styles.paymentDetailsHeading,
    mergeCss: true,
    variant: "body",
    fontFamily,
    size: "18px",
    lineHeight: "32px",
    weight: 700,
    css: css`
        padding-bottom: 4px;
        margin-bottom: 20px;
        border-bottom: 3px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
    `,
};

styles.paymentMethodAndPONumberContainer = {
    ...styles.paymentMethodAndPONumberContainer,
    gap: 20,
    css: css`
        margin-bottom: 0;
    `,
};

styles.paymentMethodSelect = {
    ...styles.paymentMethodSelect,
    ...checkoutInputSelectorStyling(styles.paymentMethodSelect),
    labelProps: {
        weight: "bold",
        css: css`
            margin-bottom: 0;
        `,
    },
};

styles.vatNumberText = {
    ...styles.vatNumberText,
    ...checkoutInputSelectorStyling(styles.vatNumberText),
};

styles.poNumberText = {
    ...styles.poNumberText,
    ...checkoutInputSelectorStyling(styles.poNumberText),
    labelProps: {
        weight: "bold",
        css: css`
            margin-bottom: 0;
        `,
    },
};

styles.creditCardDetails = {
    ...styles.creditCardDetails,
    creditCardDetailsContainer: {
        ...styles.creditCardDetails?.creditCardDetailsContainer,
        gap: 20,
    },
    creditCardDetailsHeading: {
        ...styles.creditCardDetails?.creditCardDetailsHeading,
        forwardAs: "h3",
        mergeCss: true,
        variant: "body",
        fontFamily,
        size: "18px",
        lineHeight: "32px",
        weight: 700,
    },
    cardHolderNameText: {
        ...styles.creditCardDetails?.cardHolderNameText,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.cardHolderNameText),
    },
    cardNumberTokenExFrame: {
        ...styles.creditCardDetails?.cardNumberTokenExFrame,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.cardNumberTokenExFrame),
    },
    cardNumberText: {
        ...styles.creditCardDetails?.cardNumberText,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.cardNumberText),
    },
    cardTypeSelect: {
        ...styles.creditCardDetails?.cardTypeSelect,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.cardTypeSelect),
    },
    expirationDateContainer: {
        ...styles.creditCardDetails?.expirationDateContainer,
        gap: 20,
    },
    expirationMonthSelect: {
        ...styles.creditCardDetails?.expirationMonthSelect,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.expirationMonthSelect),
    },
    expirationYearSelect: {
        ...styles.creditCardDetails?.expirationYearSelect,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.expirationYearSelect),
    },
    securityCodeTokenExFrame: {
        ...styles.creditCardDetails?.securityCodeTokenExFrame,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.securityCodeTokenExFrame),
    },
    securityCodeText: {
        ...styles.creditCardDetails?.securityCodeText,
        ...checkoutInputSelectorStyling(styles.creditCardDetails?.securityCodeText),
    },
    creditCardDetailsHeadingGridItem: {
        ...styles.creditCardDetails?.creditCardDetailsHeadingGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    saveCardGridItem: {
        ...styles.creditCardDetails?.saveCardGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    paymetricGridItem: {
        ...styles.creditCardDetails?.paymetricGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    cardHolderNameGridItem: {
        ...styles.creditCardDetails?.cardHolderNameGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    cardNumberGridItem: {
        ...styles.creditCardDetails?.cardNumberGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    cardTypeGridItem: {
        ...styles.creditCardDetails?.cardTypeGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    expirationMonthGridItem: {
        ...styles.creditCardDetails?.expirationMonthGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    expirationYearGridItem: {
        ...styles.creditCardDetails?.expirationYearGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    securityCodeGridItem: {
        ...styles.creditCardDetails?.securityCodeGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
};

styles.creditCardAddress = {
    ...styles.creditCardAddress,
    container: {
        ...styles.creditCardAddress?.container,
        gap: 10,
    },
    heading: {
        ...styles.creditCardAddress?.heading,
        forwardAs: "h3",
        mergeCss: true,
        variant: "body",
        fontFamily,
        size: "18px",
        lineHeight: "32px",
        weight: 700,
    },
    address1Text: {
        ...styles.creditCardAddress?.address1Text,
        ...checkoutInputSelectorStyling(styles.creditCardAddress?.address1Text),
    },
    countrySelect: {
        ...styles.creditCardAddress?.countrySelect,
        ...checkoutInputSelectorStyling(styles.creditCardAddress?.countrySelect),
    },
    stateSelect: {
        ...styles.creditCardAddress?.stateSelect,
        ...checkoutInputSelectorStyling(styles.creditCardAddress?.stateSelect),
    },
    cityText: {
        ...styles.creditCardAddress?.cityText,
        ...checkoutInputSelectorStyling(styles.creditCardAddress?.cityText),
    },
    postalCodeText: {
        ...styles.creditCardAddress?.postalCodeText,
        ...checkoutInputSelectorStyling(styles.creditCardAddress?.postalCodeText),
    },
    headingGridItem: {
        ...styles.creditCardAddress?.headingGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    useBillingAddressGridItem: {
        ...styles.creditCardAddress?.useBillingAddressGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    billingAddressGridItem: {
        ...styles.creditCardAddress?.billingAddressGridItem,
        css: css`
            flex-direction: column;
            padding-bottom: 0;
        `,
    },
    address1GridItem: {
        ...styles.creditCardAddress?.address1GridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    countryGridItem: {
        ...styles.creditCardAddress?.countryGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    stateGridItem: {
        ...styles.creditCardAddress?.stateGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    cityGridItem: {
        ...styles.creditCardAddress?.cityGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
    postalCodeGridItem: {
        ...styles.creditCardAddress?.postalCodeGridItem,
        css: css`
            padding-bottom: 0;
        `,
    },
};

styles.poNumberGridItem = {
    ...styles.poNumberGridItem,
    css: css`
        flex-direction: column;
    `
};

styles.counterGrid = {
    ...styles.counterGrid,
    gap: 0,
    dir: "row",
    css: css`
        margin-top: 4px;

        ${GridOffset} {
            justify-content: space-between;
        }
    `,
};

styles.counterLeftItem = {
    ...styles.counterLeftItem,
    width: 12,
    css: css`
        max-width: none;
        flex-basis: auto;
    `,
};

styles.counterRightItem = {
    ...styles.counterRightItem,
    width: 12,
    css: css`
        max-width: none;
        flex-basis: auto;
    `,
};

styles.counterTypography = {
    ...styles.counterTypography,
    size: 12,
};
